// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.notifications.RentalManagerUserNotificationsWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserNotificationsWebApiHandler_allNotifications,
  RentalManagerUserNotificationsWebApiHandler_allNotifications_Path,
  RentalManagerUserNotificationsWebApiHandler_delete,
  RentalManagerUserNotificationsWebApiHandler_markAllAsRead,
  RentalManagerUserNotificationsWebApiHandler_markAsRead,
  RentalManagerUserNotificationsWebApiHandler_tracking,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  RentalManagerNotificationDeviceType,
  UserNotificationsAllNotificationsResponseWebDto,
  UserNotificationsDeleteWebDto,
  UserNotificationsMarkAsReadWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface AllNotificationsParams {
  includeHasNewNotificationsForNotificationCenter?: boolean;
  limit?: number;
  start?: number;
}
interface DeleteParams {
  notificationId: number;
}
interface MarkAsReadParams {
  notificationId: number;
}
interface TrackingParams {
  deviceType: RentalManagerNotificationDeviceType;
  event: string;
  pushNotificationId: string;
  rentalManagerNotificationId: number;
}

export type RentalManagerUserNotificationsWebApiHandler_allNotifications_Options = UseQueryOptions<
  UserNotificationsAllNotificationsResponseWebDto,
  unknown,
  UserNotificationsAllNotificationsResponseWebDto,
  Array<string | AllNotificationsParams>
>;

const RentalManagerUserNotificationsWebApiHandler_allNotifications_GetKey = (getParams: AllNotificationsParams) => [
  RentalManagerUserNotificationsWebApiHandler_allNotifications_Path,
  getParams,
];

/**
 * Get all notifications of a user
 */
export const useRentalManagerUserNotificationsWebApiHandler_allNotifications = (
  getParams: AllNotificationsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserNotificationsWebApiHandler_allNotifications_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerUserNotificationsWebApiHandler_allNotifications_GetKey(getParams),
    queryFn: () => RentalManagerUserNotificationsWebApiHandler_allNotifications(getParams, httpClient),
  });
};
useRentalManagerUserNotificationsWebApiHandler_allNotifications.getKey =
  RentalManagerUserNotificationsWebApiHandler_allNotifications_GetKey;

export interface RentalManagerUserNotificationsWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserNotificationsWebApiHandler_delete_Options = UseMutationOptions<
  UserNotificationsDeleteWebDto,
  unknown,
  RentalManagerUserNotificationsWebApiHandler_delete_Args
>;

/**
 * Delete a notification
 */
export const useRentalManagerUserNotificationsWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserNotificationsWebApiHandler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserNotificationsWebApiHandler_delete_Args) =>
      RentalManagerUserNotificationsWebApiHandler_delete(args.getParams, httpClient),
  });
};

export type RentalManagerUserNotificationsWebApiHandler_markAllAsRead_Options = UseMutationOptions<void, unknown, void>;

/**
 * Mark all notifications as read
 */
export const useRentalManagerUserNotificationsWebApiHandler_markAllAsRead = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserNotificationsWebApiHandler_markAllAsRead_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => RentalManagerUserNotificationsWebApiHandler_markAllAsRead(httpClient),
  });
};

export interface RentalManagerUserNotificationsWebApiHandler_markAsRead_Args {
  getParams: MarkAsReadParams;
}

export type RentalManagerUserNotificationsWebApiHandler_markAsRead_Options = UseMutationOptions<
  UserNotificationsMarkAsReadWebDto,
  unknown,
  RentalManagerUserNotificationsWebApiHandler_markAsRead_Args
>;

/**
 * Mark a notification as read
 */
export const useRentalManagerUserNotificationsWebApiHandler_markAsRead = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserNotificationsWebApiHandler_markAsRead_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserNotificationsWebApiHandler_markAsRead_Args) =>
      RentalManagerUserNotificationsWebApiHandler_markAsRead(args.getParams, httpClient),
  });
};

export interface RentalManagerUserNotificationsWebApiHandler_tracking_Args {
  getParams: TrackingParams;
}

export type RentalManagerUserNotificationsWebApiHandler_tracking_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserNotificationsWebApiHandler_tracking_Args
>;

/**
 * Track push notifications events
 */
export const useRentalManagerUserNotificationsWebApiHandler_tracking = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserNotificationsWebApiHandler_tracking_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserNotificationsWebApiHandler_tracking_Args) =>
      RentalManagerUserNotificationsWebApiHandler_tracking(args.getParams, httpClient),
  });
};
